define('evicommon/search.util',['require','exports','module','underscore','./search/search.criteria','./search/search.filter','./search/search.service.filter','./search/search.field','./search/visual.search.helper','./search/search.adapter'],function(require, exports, module) {
  //prettier-ignore
  var _                   = require('underscore'),
      SearchCriteria      = require('./search/search.criteria'),
      SearchFilter        = require('./search/search.filter'),
      SearchServiceFilter = require('./search/search.service.filter'),
      SearchField         = require('./search/search.field'),
      VSHelper            = require('./search/visual.search.helper'),
      SearchAdapter       = require('./search/search.adapter');

  var SearchUtil = {
    createSearchAdapter: function(filters, options) {
      return new SearchAdapter(filters, options);
    },

    createSearchCriteriaFromMap: function(filterMap) {
      var filters = new SearchCriteria.Collection();
      _.chain(filterMap)
        .keys()
        .map(function(key) {
          return { key: key, value: filterMap[key] };
        })
        .each(function(entry) {
          var filter = filters.addFilterWithField({ name: entry.key });
          filter.value(entry.value);
        })
        .value();

      return filters;
    },

    createSearchServiceCriteria: function(searchServiceQueryFields, additionalSearchServiceParams) {
      var filterObj = new SearchServiceFilter();

      if (searchServiceQueryFields) {
        filterObj.set({
          queryFields: searchServiceQueryFields,
          additionalParams: additionalSearchServiceParams,
        });
      }

      return filterObj;
    },

    // Legacy support, in case something somewhere references the old method name
    createSearchCriteria: function(search, fields) {
      return this.createTraditionalSearchCriteria(search, fields);
    },

    createTraditionalSearchCriteria: function(search, fields) {
      return SearchCriteria.Collection.createFromStringAndFields(search, fields);
    },

    createSearchFields: function(fields) {
      return new SearchField.Collection(fields);
    },

    createVSHelper: function(vsInput, fields, filters) {
      return new VSHelper(vsInput, fields, filters);
    },
  };

  module.exports = SearchUtil;
});

